module.exports = __webpack_public_path__ + "static/media/toSelect.b7cbe13c.png";